import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Error boundary that wraps individual sections so one broken section
 * does not take down the entire page render.
 */
export class SectionErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[SectionErrorBoundary] A section threw during render:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-text-muted text-sm py-4 text-center">
          This section couldn't be rendered.
        </div>
      );
    }
    return this.props.children;
  }
}
